import { z } from 'zod';

import { OrderDirection } from '@/constants/orderDirection';

import { SortColumns } from './-components/columns';

export const SearchSchema = z.object({
  freeText: z.string().optional(),
  boardMemberTypeIdIn: z.array(z.string()).optional(),
  placeIdIn: z.array(z.string()).optional(),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  sortColumn: z
    .enum([
      SortColumns.PERSON_NAME,
      SortColumns.WORKER_TYPE,
      SortColumns.JOB_TYPE,
      SortColumns.PLACE,
    ])
    .optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
});

export type SearchSchema = z.infer<typeof SearchSchema>;
